(function () {
  'use strict';

  function shopRoot() {
    var rawRoot = document.documentElement.getAttribute('data-shop-root') || '/';
    var parts = rawRoot.split('/').filter(Boolean);
    return parts.length ? '/' + parts[0] : '';
  }

  function cleanInternalUrl(rawHref) {
    if (!rawHref || rawHref.charAt(0) === '#' || /^(mailto:|tel:|sms:|javascript:)/i.test(rawHref)) {
      return rawHref;
    }

    var parsed;
    try {
      parsed = new URL(rawHref, window.location.href);
    } catch (error) {
      return rawHref;
    }

    if (parsed.origin !== window.location.origin) return rawHref;

    var matches = Array.from(parsed.pathname.matchAll(/\/(collections|products|pages)\/([^/?#]+)/g));
    if (!matches.length) return rawHref;

    var destination = matches[matches.length - 1];
    return shopRoot() + '/' + destination[1] + '/' + destination[2] + parsed.search + parsed.hash;
  }

  function cleanLink(link) {
    if (!link || !link.getAttribute) return;
    var currentHref = link.getAttribute('href');
    var cleanHref = cleanInternalUrl(currentHref);
    if (cleanHref && cleanHref !== currentHref) link.setAttribute('href', cleanHref);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href]').forEach(cleanLink);

    var menuToggle = document.querySelector('[data-menu-toggle]');
    var menuDrawer = document.querySelector('[data-menu-drawer]');
    if (menuToggle && menuDrawer) {
      menuToggle.addEventListener('click', function () {
        menuDrawer.classList.toggle('open');
        document.body.classList.toggle('no-scroll');
      });
    }

    document.querySelectorAll('[data-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var content = button.nextElementSibling;
        button.classList.toggle('active');
        if (content) content.style.maxHeight = content.style.maxHeight ? null : content.scrollHeight + 'px';
      });
    });
  });

  /* Also protects links inserted later by app blocks or theme-editor updates. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    cleanLink(link);
  }, true);
})();
